export default {
    ADMIN_MP: 1,
    SUPER_USER: 2,
    USER: 4,
    ADMIN: 5
};



// WEBPACK FOOTER //
// ./src/enums/ProfileEnum.js